import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

export function Alert({ 
    title, 
    message, 
    type = 'info', 
    onClose,
    className = '' 
}) {
    const typeConfig = {
        success: { 
            icon: 'check_circle', 
            bg: 'bg-green-50 dark:bg-green-500/10', 
            border: 'border-green-200 dark:border-green-500/20',
            text: 'text-green-800 dark:text-green-200',
            iconColor: 'text-green-500'
        },
        error: { 
            icon: 'error', 
            bg: 'bg-red-50 dark:bg-red-500/10', 
            border: 'border-red-200 dark:border-red-500/20',
            text: 'text-red-800 dark:text-red-200',
            iconColor: 'text-red-500'
        },
        warning: { 
            icon: 'warning', 
            bg: 'bg-amber-50 dark:bg-amber-500/10', 
            border: 'border-amber-200 dark:border-amber-500/20',
            text: 'text-amber-800 dark:text-amber-200',
            iconColor: 'text-amber-500'
        },
        info: { 
            icon: 'info', 
            bg: 'bg-blue-50 dark:bg-blue-500/10', 
            border: 'border-blue-200 dark:border-blue-500/20',
            text: 'text-blue-800 dark:text-blue-200',
            iconColor: 'text-blue-500'
        }
    };

    const config = typeConfig[type];

    return (
        <AnimatePresence>
            <motion.div
                layout
                initial={{ opacity: 0, height: 0, scale: 0.95 }}
                animate={{ opacity: 1, height: 'auto', scale: 1 }}
                exit={{ opacity: 0, height: 0, scale: 0.95, margin: 0 }}
                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                className={`overflow-hidden ${className}`}
            >
                <div className={`p-4 rounded-xl border flex gap-3 ${config.bg} ${config.border}`}>
                    <ObliqueIcon name={config.icon} className={`shrink-0 mt-0.5 ${config.iconColor}`} size={20} />
                    <div className="flex-1">
                        {title && <h3 className={`text-sm font-semibold mb-1 ${config.text}`}>{title}</h3>}
                        <p className={`text-sm ${config.text} opacity-90`}>{message}</p>
                    </div>
                    {onClose && (
                        <button 
                            onClick={onClose}
                            className={`shrink-0 p-1 rounded-md opacity-70 hover:opacity-100 hover:bg-black/5 dark:hover:bg-white/5 transition-colors cursor-pointer outline-none ${config.text}`}
                        >
                            <ObliqueIcon name="close" size={16} />
                        </button>
                    )}
                </div>
            </motion.div>
        </AnimatePresence>
    );
}
